import { LatencyMeasurePoint } from 'core/models/latency';
import { downloadFile } from '../utility/downloadFile';
import { dateToTimeString } from '../utility/time';

export function exportLatencyData(measurements: LatencyMeasurePoint) {
    const json: { timestamp: string; measurements: {}[]; }[] = [];
    measurements.map(point => {
        const latencyDataArray: {}[] = [];
        point.cameras.map(camera => {
            const latencyData = camera.channels.map(m => m.measurement);
            latencyDataArray.push(camera.tag, latencyData);
        });
        json.push({ 'timestamp': dateToTimeString(point.time), 'measurements': latencyDataArray });
    });

    downloadFile(JSON.stringify(json), 'latency.json', 'text/json');
}
